import React from "react";
import {
  Card,
  CardContent,
  Table,
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Stack,
} from "@mui/material";
import NoData from "components/NoData";
import { I18n } from "@aws-amplify/core";
import useMediaQuery from "@mui/material/useMediaQuery";

const ContactsCard = ({ data }) => {
  const isMobileDevice = useMediaQuery("(max-width:600px)");
  const headerCellsContact = [
    {
      id: "phone",
      label: I18n.get("Phone"),
      align: "left",
      flex: 1,
      rendercell: (params) => (
        <Typography
          component="a"
          href={`tel:${params.value}`}
          sx={{
            fontSize: "medium",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          {params.value}
        </Typography>
      ),
    },
    { id: "fax", label: I18n.get("Fax"), align: "left", flex: 1 },
    {
      id: "email",
      label: I18n.get("Email"),
      align: "left",
      flex: 1,
      rendercell: (params) => (
        <Typography
          component="a"
          href={`mailto:${params.value}`}
          sx={{
            fontSize: "medium",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          {params.value}
        </Typography>
      ),
    },
    {
      id: "website",
      label: I18n.get("Website"),
      align: "left",
      flex: 1,
      rendercell: (params) => (
        <Typography
          component="a"
          href={`https://${params.value}`}
          sx={{
            fontSize: "medium",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          {params.value}
        </Typography>
      ),
    },
  ];

  if (!data || Object.keys(data).length === 0) {
    return (
      <Card>
        <CardContent>
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ pb: 2 }}
          >
            <Typography variant="h5">{I18n.get("Contacts")}</Typography>
          </Stack>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NoData />
          </Box>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{marginBottom:"1rem"}}>
       <CardContent sx={{"&:last-child":{padding:"1rem"} }}>
        <Stack
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ pb: 2 }}
        >
          <Typography variant="h5">{I18n.get("Contacts")}</Typography>
        </Stack>
        <TableContainer>
          <Table>
            <TableBody>
              {headerCellsContact.map((column, colIndex) => (
                <React.Fragment key={colIndex}>
                  <TableCell
                    style={{
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      padding: "0px",
                      borderBottom: "1px solid #e0e0e0",
                      fontSize: "14px",
                      lineHeight: 1.6,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "15px",
                      }}
                    >
                      {column.label}:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      {column.rendercell
                        ? column.rendercell({
                            value: data[column.id],
                            row: data,
                          })
                        : data[column.id] !== undefined &&
                          data[column.id] !== null &&
                          data[column.id] !== "N/A"
                        ? data[column.id]
                        : ""}
                    </Typography>
                  </TableCell>
                  {(colIndex + 1) % (isMobileDevice ? 1 : 2) === 0 && (
                    <TableRow key={`spacer-${colIndex}`}></TableRow>
                  )}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default ContactsCard;
